import { AcknowledgementName } from "@wingspanhq/wingspan-api-sdk";
import { acknowledgementInfo } from "../../../shared/constants/acknowledgements";

type Props = {
  aknowledgements: AcknowledgementName[];
};

export const Acknowledgements: React.FC<Props> = ({ aknowledgements }) => (
  <ol>
    {aknowledgements.map(aknowledgement =>
      acknowledgementInfo[aknowledgement] ? (
        <li key={aknowledgement}>
          <a
            href={acknowledgementInfo[aknowledgement]?.link}
            target="_blank"
            rel="noreferrer"
          >
            {acknowledgementInfo[aknowledgement]?.title}
          </a>
          : {acknowledgementInfo[aknowledgement]?.description}
        </li>
      ) : null
    )}
  </ol>
);
